import React, { useEffect } from 'react'
import CompasIcon from '../svg/CompasIcon'
import HappyStudentsIcon from '../svg/HappyStudentsIcon'
import LifebeltIcon from '../svg/LifebeltIcon'
import CheckmarkIcon from '../svg/CheckmarkIcon'
import ArrowRight from '../svg/Arrows/ArrowRight'
import { Link, useRouteMatch } from 'react-router-dom'
import '../styles/IssueTopicOverview.css'
import i18n from '../i18n'
import { useTranslation } from 'react-i18next'
import { useUser } from '../context/user'
import { create } from '../server/server'

export default function IssueTopicOverview({ issueTopic }) {
    const { t } = useTranslation()
    const { user } = useUser()
    const takeAways = issueTopic.key_takeaway ? [issueTopic.key_takeaway['0'], issueTopic.key_takeaway['1'], issueTopic.key_takeaway['2']] : []
    const { url } = useRouteMatch()

    const studentCheckingSolution = async () => {
        const data = {
            user_id: user.id,
            solution_id: issueTopic.id,
            device: 'web',
        }
        create({ collection: 'studentCheckingSolutions', data })
    }

    useEffect(() => {
        studentCheckingSolution()
    }, [])

    return (
        <div className="issue-topic-overview-container">
            <div className="issue-topic-desc shadow-custom-soft">{issueTopic.description}</div>
            <span className="issue-topic-overview-title">{t('findTheRightSolution')}</span>

            <Link
                to={{
                    pathname: `${url}/immediate-solutions`,
                    state: {
                        issueTopic: issueTopic,
                        solutions: issueTopic.explore_things,
                    },
                }}
            >
                <div className="issue-topic-section-link explore-issue-link shadow-custom-soft">
                    <div className="issue-topic-overview-link-icon">
                        <CompasIcon className={i18n.language === 'ar' ? 'ar-transform' : ''} />
                    </div>
                    <div className="issue-topic-overview-link-title">{t('exploreThingsYouCanDoRightNow')}</div>
                    <div className="issue-topic-overiview-link-arrow">
                        <div className="circle-30 fully-centered">
                            <ArrowRight className={i18n.language === 'ar' ? 'ar-transform' : ''} />
                        </div>
                    </div>
                </div>
            </Link>
            <Link
                to={{
                    pathname: `${url}/other-student-solutions`,
                    state: issueTopic.how_students_handle_it,
                }}
            >
                <div className="issue-topic-section-link shadow-custom-soft">
                    <div className="issue-topic-overview-link-icon">
                        <HappyStudentsIcon className={i18n.language === 'ar' ? 'ar-transform' : ''} />
                    </div>
                    <div className="issue-topic-overview-link-title">{t('seeHowOtherStudentsHandleThis')}</div>
                    <div className="issue-topic-overiview-link-arrow">
                        <div className="circle-30 fully-centered">
                            <ArrowRight className={i18n.language === 'ar' ? 'ar-transform' : ''} />
                        </div>
                    </div>
                </div>
            </Link>
            <Link to={`${url}/contact-coach-solution`}>
                <div className="issue-topic-section-link shadow-custom-soft">
                    <div className="issue-topic-overview-link-icon">
                        <LifebeltIcon />
                    </div>
                    <div className="issue-topic-overview-link-title">{t('connectWithTheConselor')}</div>
                    <div className="issue-topic-overiview-link-arrow">
                        <div className="circle-30 fully-centered">
                            <ArrowRight className={i18n.language === 'ar' ? 'ar-transform' : ''} />
                        </div>
                    </div>
                </div>
            </Link>

            {takeAways.length !== 0 && (
                <div className="issue-topic-overview-takeaways shadow-custom-soft">
                    <div className="issue-topic-overview-takeaways-title">{t('quickTips')}</div>
                    {takeAways.map((takeAway, key) => (
                        <div className="takeaway-item" key={key}>
                            <div className="takeaway-item-icon">
                                <CheckmarkIcon />
                            </div>
                            <div className="takeaway-item-text">
                                <span>{takeAway}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
